import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Discrepancy';
  currentRoute: any;
  ifHideHeader = false;
  // headerPermission = true;
  constructor(private router: Router, private authService: AuthService, private bnIdle: BnNgIdleService) {
    // this.headerPermission = this.authService.hasPermissionValue === true ? true : false;
    this.router.events.subscribe(value => {
      if (this.router.url.toString() === '/report-discrep') {
        this.ifHideHeader = true;
      } else {
        this.ifHideHeader = false;
      }
    });
    //session expire
    this.bnIdle.startWatching(environment.timeout).subscribe((res) => {
      if (res) {
        console.log("session expired", res);
        window.location.href = environment.aeroHomeUrl;
      }
    })
  }
}
